// start:ng42.barrel
export * from './IAdditionalGuests';
export * from './IAncillaryReservations';
export * from './IAssociationData';
export * from './ICommunicationPreferences';
export * from './ICreditCard';
export * from './IDailyPrice';
export * from './IDiscounts';
export * from './IGuest';
export * from './IGuestAddress';
export * from './IHotelReservation';
export * from './IIhgConfirmationNumber';
export * from './IPayment';
export * from './IPointsAndCashOptions';
export * from './IRateChanges';
export * from './IReservationEnrollment';
export * from './IRewardNightRate';
export * from './ISpecialNightRate';
export * from './IStay';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/HotelReservation/index.ts